export default __webpack_public_path__ + "media/maiya.7d91847a.jpg";